export const LINK_POLL_INTERVAL_MS = 3_000,
  LINK_POLL_WINDOW_MS = 120_000;

export type LinkFlowState =
  | { phase: 'closed' }
  | { phase: 'waiting'; startedAt: number }
  | { phase: 'linked' }
  | { phase: 'timedOut' };

export type LinkFlowEvent =
  | { type: 'open'; now: number }
  | { type: 'status'; linked: boolean; now: number }
  | { type: 'tick'; now: number }
  | { type: 'retry'; now: number }
  | { type: 'close' };

/**
 * status linked -> 'linked' (de waiting OU timedOut: a volta da aba pode trazer
 * o vínculo depois do prazo); tick com now - startedAt >= 120 s -> 'timedOut';
 * retry -> waiting(now).
 */
export function linkFlowReducer(
  s: LinkFlowState,
  e: LinkFlowEvent
): LinkFlowState {
  switch (e.type) {
    case 'open':
      return { phase: 'waiting', startedAt: e.now };
    case 'status':
      return e.linked && (s.phase === 'waiting' || s.phase === 'timedOut')
        ? { phase: 'linked' }
        : s;
    case 'tick':
      return s.phase === 'waiting' && e.now - s.startedAt >= LINK_POLL_WINDOW_MS
        ? { phase: 'timedOut' }
        : s;
    case 'retry':
      return s.phase === 'closed' ? s : { phase: 'waiting', startedAt: e.now };
    case 'close':
      return { phase: 'closed' };
  }
}

export function shouldPoll(s: LinkFlowState): boolean {
  return s.phase === 'waiting';
}

/**
 * Único lugar que monta o deep link. O parâmetro continua se chamando
 * `adminUserId` porque o app da loja (inalterado) repassa esse valor; o
 * conteúdo é o ticket de uso único (B1).
 */
export function buildTestDeviceDeepLink(
  appScheme: string,
  ticket: string
): string {
  return `${appScheme}://register-test-device?adminUserId=${encodeURIComponent(ticket)}`;
}

/** No timedOut o QR/botão somem: ticket nunca vencido na tela. */
export function shouldShowDeepLink(s: LinkFlowState): boolean {
  return s.phase === 'waiting';
}
